import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getHospitals } from '../../../api/hospitalApi';

interface Hospital {
  id: number;
  name: string;
}


interface HospitalsState {
  hospitals: Hospital[];
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: HospitalsState = {
  hospitals: [],
  loading: false,
  error: null,
  success: false,
};

export const fetchHospitals = createAsyncThunk(
  'hospitals/fetch',
  async (
    { language }: { language?: 'az' | 'en' } = {},
    { rejectWithValue }
  ) => {
    try {
      const result = await getHospitals(language || 'az');

      if (result.status === 200) {
        const data = result.data as { results: Hospital[] };
        return data.results;
      } else {
        return rejectWithValue(result.data);
      }
    } catch (error) {
      return rejectWithValue({
        error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
      });
    }
  }
);


const hospitalsSlice = createSlice({
  name: 'hospitals',
  initialState,
  reducers: {

    resetHospitals: (state) => {
      state.hospitals = [];
      state.loading = false;
      state.error = null;
      state.success = false;
    },

    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchHospitals.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(fetchHospitals.fulfilled, (state, action: PayloadAction<Hospital[]>) => {
        state.loading = false;
        state.hospitals = action.payload;
        state.success = true;
        state.error = null;
      })
      .addCase(fetchHospitals.rejected, (state, action) => {
        state.loading = false;
        state.success = false;

        const payload = action.payload as any;

        if (payload?.error) {
          state.error = payload.error;
        }
        else {
          state.error = 'Xəstəxanaların yüklənməsi zamanı xəta baş verdi';
        }
      });
  },
});

export const { resetHospitals, clearError } = hospitalsSlice.actions;

export default hospitalsSlice.reducer;